import _ from 'lodash'

export function getProducts(state) {
  let products = state.products.list;
  const searchTerm = state.products.searchTerm && state.products.searchTerm.toLocaleLowerCase();

  products = _.filter(products, (p) => {
    const title = p.name || p.title || '';

    return new RegExp(searchTerm).test(title.toLowerCase())
  });

  return products;
}

export function getFavorites(state) {
  let products = state.products.list;

  products = _.filter((products || []), (p) => p.weight);

  return _.sortBy(products, function (product) {
    return -product.weight;
  });
}


// WEBPACK FOOTER //
// ./src/components/Products/selectors/products.js